<template>
  <div class="page-container">
    <div class="coupon-box">
      <div class="left">
        <couponPrice :price="couponInfo.couponValue" />
        <div class="condition">
          {{ couponCondition }}
        </div>
      </div>
      <div class="right">
        <div class="coupon-name van-ellipsis">{{ couponInfo.couponName }}</div>
        <div class="des">
          <div>有效时间</div>
          <div>{{ couponTopTime }}</div>
        </div>
      </div>
    </div>
    <div class="use-rule-box">
      <div class="title">使用规则</div>
      <div class="content">
        <div class="item">
          <label>有效时间：</label>
          <div class="val">{{ couponTime }}</div>
        </div>
        <div class="item">
          <label>使用范围：</label>
          <div class="val">{{ couponInfo.useType }}</div>
        </div>
        <div class="item">
          <label>使用门槛：</label>
          <div class="val">{{ couponCondition }}</div>
        </div>
      </div>
    </div>
    <div class="btnfooter">
      <div class="footer-wrp">
        <template v-if="from == 1">
          <van-button
            v-if="fromType"
            class="btn"
            :loading="loading"
            color="linear-gradient(180deg, #fe5f70 0%, #fe3a4a 100%)"
            block
            round
            @click="() => (rid ? goUse() : handleReceiveCoupon())"
            type="primary"
            >{{ rid ? '去使用' : '领取' }}</van-button
          >
          <van-button
            v-else
            class="btn"
            :loading="loading"
            color="linear-gradient(180deg, #fe5f70 0%, #fe3a4a 100%)"
            block
            round
            type="primary"
            @click="() => (rid ? goUse() : handleExchange())"
            >{{ rid ? '立即使用' : `${couponInfo.integral}${integralName}兑换` }}</van-button
          ></template
        >
        <template v-else-if="from == 2 && ower">
          <van-button
            v-if="couponDetail.isTransferOut == 1"
            class="btn"
            :loading="loading"
            color="linear-gradient(180deg, #fe5f70 0%, #fe3a4a 100%)"
            block
            round
            @click="showCancelPop()"
            type="primary"
            >取消赠送</van-button
          >
          <van-button
            v-else-if="couponDetail.isTransferOut == 2"
            class="btn"
            :loading="loading"
            color="linear-gradient(180deg, #fe5f70 0%, #fe3a4a 100%)"
            block
            round
            type="primary"
            @click="showReciverInfo()"
            >查看领取详情</van-button
          ></template
        >
      </div>
    </div>

    <van-popup v-model:show="showReciver" round position="bottom" :style="{ minHeight: '30%' }">
      <div class="coupon-wrap">
        <div class="coupon pt-20px px-20px">
          <div class="coupon-title mb-24px">好友已领取</div>
          <div class="coupon-content">
            <div class="coupon-card py-24px">
              <van-image
                class="coupon-logo"
                round
                :width="transPxToRem(60)"
                :height="transPxToRem(60)"
                :src="couponDetail.transferReceiveAvatarurl || defaultAvatar"
              />
              <div class="coupon-nickname my-10px">{{ couponDetail.transferReceiveNickname }}</div>
              <div class="coupon-mobile">{{ couponDetail.transferReceiveMobile }}</div>
              <div class="coupon-time mt-10px">领取时间: {{ couponDetail.transferReceiveTime }}</div>
            </div>
          </div>
        </div>

        <van-button round class="coupon-button" @click="showReciverInfo()">知道了</van-button>
      </div>
    </van-popup>

    <van-popup v-model:show="showCancel" class="popup" round custom-style="overflow-y: visible;">
      <div class="pop-wrap">
        <div class="pop-title">提示</div>
        <div class="pop-content">取消转赠后，好友无法领取该优惠券，确认是否取消？</div>
        <div class="pop-bottom flex">
          <div class="pop-button" @click="showCancelPop()">取消</div>
          <van-button round class="pop-button confirm-button" type="primary" @click="confirmCancel()">确认</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup lang="jsx">
import { ref, onMounted, computed } from 'vue'
import couponPrice from './component/couponPrice.vue'
import {
  getIntegralShopCouponDetailApi,
  receiveIntegralCouponApi,
  getParamsCouponDetail,
  receiveCouponApi
} from '@/api/integral'
import { getMemberCouponDetailApi, postCancelCouponTransferApi } from '@/api/coupon'
import { useRoute } from 'vue-router'
import { showToast } from 'vant'
// import { useCssVar } from '@vueuse/core'
import { useUserStore } from '@/store/user'
import usePage from '@/hooks/usePage'
import { transPxToRem } from '@/utils'
// import usePage from '@/hooks/usePage'
// import { WxPage } from '../../enum'
const { query } = useRoute()
const defaultAvatar = ref('https://i.xurl.cn/x_dsx_h5/icons/default-head-white.png')
const { navigateTo } = usePage()
const userStore = useUserStore()
const userInfo = computed(() => userStore.getUserInfo || {}) //用户信息
const BigSixBg = ''
const activityId = Number(query.activityId || 0)
const couponId = Number(query.couponId || 0) // couponId
const fromType = Number(query?.type || 0)
const paramsId = Number(query?.paramsId || 0)
const couponRid = Number(query.rid || 0) // rid为后端组件id
const from = Number(query.from || 1) // // 1：平台券 2: 用户个人券 本质上是视角问题，这里是为了区分我转赠出的券
const transferId = Number(query.transferId || 0) // transferId为转发ID，转发给谁id不同
const couponInfo = ref({
  couponName: '',
  couponEffectDay: 0,
  couponValue: 11,
  useConditionType: 1,
  useConditionValue: '11',
  effectiveStartTime: '',
  effectiveEndTime: '',
  integral: 0
})
const couponDetail = ref({})
const rmSecond = s => s.slice(0, -3)
const effectiveStartTime = computed(() => couponInfo.value.effectiveStartTime)
const effectiveEndTime = computed(() => couponInfo.value.effectiveEndTime)
const couponEffectDay = computed(() => couponInfo.value.couponEffectDay)

const couponTopTime = computed(() =>
  couponEffectDay.value
    ? `领取后${couponEffectDay.value}天内有效`
    : `${rmSecond(effectiveStartTime.value)}~${rmSecond(effectiveEndTime.value)}`
)

const couponTime = computed(() =>
  couponEffectDay.value
    ? `领取后${couponEffectDay.value}天内有效`
    : `${effectiveStartTime.value}~${effectiveEndTime.value}`
)

const couponCondition = computed(() =>
  couponInfo.value.useConditionType === 1
    ? '无门槛'
    : `满${couponInfo.value.useConditionValue}${couponInfo.value.useConditionType === 2 ? '元' : '件'}可用`
)

const ower = computed(() => couponDetail.value.puid == userInfo.value.puid) //“我的券”
const loading = ref(false)
const rid = ref(0)

const handleExchange = async () => {
  loading.value = true
  try {
    const resData = await receiveIntegralCouponApi({ activityId, couponId })
    if (resData) {
      rid.value = Number(resData.rid)
      showToast('兑换成功')
    }
  } finally {
    setTimeout(() => {
      loading.value = false
    }, 300)
  }
}

const handleReceiveCoupon = async () => {
  loading.value = true
  try {
    const resData = await receiveCouponApi({ paramId: paramsId, couponId, type: fromType })
    if (resData) {
      rid.value = Number(resData.rid)
      showToast('领取成功')
    }
  } finally {
    setTimeout(() => {
      loading.value = false
    }, 300)
  }
}

const goUse = () => {
  navigateTo(`/couponGoodsList?rid=${rid.value}&activityId=${activityId}`)
}

const showCancel = ref(false)
const showCancelPop = () => {
  showCancel.value = !showCancel.value
}
const confirmCancel = async () => {
  try {
    const resData = await postCancelCouponTransferApi({ transferId: transferId })
    showToast('取消成功！')
    showCancelPop()
    getCouponDetail()
  } finally {
  }
}

const showReciver = ref(false)
const showReciverInfo = () => {
  showReciver.value = !showReciver.value
}

const getCouponDetail = async () => {
  try {
    const result = await getMemberCouponDetailApi({ rid: couponRid, transferId: transferId }) //部分数据 getParamsCouponDetail取不到，需要通过 rid查询
    if (result) {
      couponDetail.value = result
    }
  } finally {
  }
}

onMounted(async () => {
  // primaryColor.value = theme.value.PrimaryButtonColor
  const resData = fromType
    ? await getParamsCouponDetail({ paramsId, couponId, type: fromType })
    : await getIntegralShopCouponDetailApi({ activityId, couponId })
  if (resData) {
    couponInfo.value = resData.detail
  }
  if (couponRid > 0 || transferId > 0) {
    getCouponDetail()
  }
})
</script>
<style lang="less" scoped>
@font-primary-color: #ff6262;

.page-container {
  .coupon-box {
    display: flex;
    margin: 12px;
    .left {
      position: relative;
      padding: 14px 12px;
      text-align: center;
      border-radius: 8px;
      background: #ffffff;
      width: 100px;
      box-sizing: border-box;
      color: @font-primary-color;
      .condition {
        margin-top: 4px;
        font-size: 11px;
      }
      &:after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: 0;
        height: 80%;
        border-right: 1px dashed #d8d8d8;
      }
    }
    .right {
      flex: 1;
      border-radius: 8px;
      background: #ffffff;
      padding: 14px 16px;
      .coupon-name {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 8px;
      }
      .des {
        line-height: 16px;
        color: #666666;
      }
    }
  }
  .use-rule-box {
    background-color: #ffffff;
    margin: 12px;
    padding: 16px;
    border-radius: 8px;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    .content {
      color: #666666;
      font-size: 14px;
      line-height: 20px;
      .item {
        margin: 10px 0;
        display: flex;
        .val {
          flex: 1;
        }
      }
    }
  }
  .btnfooter {
    padding-top: 0;
    .footer-wrp {
      padding: 12px;
    }
    .btn {
      height: 40px;
    }
  }
}
.coupon-wrap {
  .coupon {
    width: 100%;
    height: 300px;
    background-image: url('https://i.xurl.cn/x_dsx_h5/market/coupon/coupon-info-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .coupon-title {
    font-weight: 500;
    font-size: 16px;
    color: #222222;
    text-align: center;
  }
  .coupon-content {
    .coupon-card {
      background: #ffffff;
      border-radius: 8px;
      text-align: center;
      .coupon-nickname {
        font-weight: 500;
        font-size: 14px;
        color: #222222;
      }
      .coupon-mobile {
        font-weight: 500;
        font-size: 14px;
        color: #222222;
      }
      .coupon-time {
        font-size: 13px;
        color: #999999;
      }
    }
  }
  .coupon-button {
    display: block;
    width: calc(100% - 40px);
    height: 40px;
    line-height: 40px;
    background: linear-gradient(180deg, #fe5f70 0%, #fe3a4a 100%);
    border-radius: 20px;
    box-sizing: border-box;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    margin: 0 auto 16px;
  }
}

.pop-wrap {
  width: 327px;
  padding: 24px 20px;
  box-sizing: border-box;
  .pop-title {
    font-weight: 500;
    font-size: 18px;
    color: #222222;
    text-align: center;
  }
  .pop-content {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    padding: 28px 0;
    text-align: center;
  }
  .pop-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .pop-button {
      flex: 1;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      height: 44px;
      line-height: 44px;
      border-radius: 22px;
      background: #f6f6f6;
    }
    .confirm-button {
      color: #ffffff;
      padding: 0;
      background: linear-gradient(180deg, #fe5f70 0%, #fe3a4a 100%);
      margin-left: 10px;
      margin-bottom: 12px;
    }
  }
}
</style>
